import {createSlice} from "@reduxjs/toolkit";

function sortUsers(array) {
    array.sort((a, b) => a.name.localeCompare(b.name));
}

export const compassSlice = createSlice({
    name: 'compass',

    initialState: {
        users: [],
        placedUsers: [],
        draggedUser: undefined,

        title: 'Political Compass',
        topLabel: 'Authoritarian',
        bottomLabel: 'Libertarian',
        leftLabel: 'Left',
        rightLabel: 'Right',
	    topLeftColor: '#000000',
	    topRightColor: '#008000',
	    bottomLeftColor: '#ffffff',
	    bottomRightColor: '#800080',
    },

    reducers: {
        initCompassUsers: (state, action) => {
            state.users = action.payload;
        },

        updateCompassDraggedUser: (state, action) => {
            state.draggedUser = action.payload;
        },

        placeCompassUser: (state, action) => {
            const {user, x, y} = action.payload;

            state.users = state.users.filter(currentUser => currentUser.id !== user.id);
            state.placedUsers = state.placedUsers.filter(currentUser => currentUser.id !== user.id);

            state.placedUsers.push({
                ...user,
                compassX: Math.max(0, Math.min(100, x)),
                compassY: Math.max(0, Math.min(100, y)),
            });
        },

        removeCompassUser: (state, action) => {
            const user = action.payload;

            state.placedUsers = state.placedUsers.filter(currentUser => currentUser.id !== user.id);

            const cleanedUser = {...user};
            delete cleanedUser.compassX;
            delete cleanedUser.compassY;

            state.users.push(cleanedUser);
            sortUsers(state.users);
        },

        updateCompassTitle: (state, action) => {
            state.title = action.payload;
        },

        updateCompassTopLabel: (state, action) => {
            state.topLabel = action.payload;
        },

        updateCompassBottomLabel: (state, action) => {
            state.bottomLabel = action.payload;
        },

        updateCompassLeftLabel: (state, action) => {
            state.leftLabel = action.payload;
        },

        updateCompassRightLabel: (state, action) => {
            state.rightLabel = action.payload;
        },

        restoreCompassState: (state, action) => {
            return {
                ...state,
                ...action.payload,
                draggedUser: undefined,
            };
        },        

        resetCompass: (state) => {
            const returnedUsers = state.placedUsers.map(user => {
                const cleanedUser = {...user};
                delete cleanedUser.compassX;
                delete cleanedUser.compassY;
                return cleanedUser;
            });

            state.users = state.users.concat(returnedUsers);
            sortUsers(state.users);
            state.placedUsers = [];
            state.draggedUser = undefined;
        },

     updateCompassTopLeftColor: (state, action) => {
	  state.topLeftColor = action.payload;
     },

     updateCompassTopRightColor: (state, action) => {
          state.topRightColor = action.payload;
     },

     updateCompassBottomLeftColor: (state, action) => {
          state.bottomLeftColor = action.payload;
     },

     updateCompassBottomRightColor: (state, action) => {
          state.bottomRightColor = action.payload;
    },
    }
});

export const {
    initCompassUsers,
    updateCompassDraggedUser,
    placeCompassUser,
    removeCompassUser,
    updateCompassTitle,
    updateCompassTopLabel,
    updateCompassBottomLabel,
    updateCompassLeftLabel,
    updateCompassRightLabel,
    updateCompassTopLeftColor,
    updateCompassTopRightColor,
    updateCompassBottomLeftColor,
    updateCompassBottomRightColor,
    restoreCompassState,
    resetCompass,
} = compassSlice.actions;

export const compassReducer = compassSlice.reducer;
